export const isInputFocused = () => {
  const el = document.activeElement;
  return (
    el?.tagName === "INPUT" ||
    el?.tagName === "TEXTAREA" ||
    el?.isContentEditable
  );
};
